module.exports = __webpack_public_path__ + "static/segmented-timeline-mobile-4eb217a5260b2a16b0e5cd7bf3325a34.webp";